export default "__VITE_ASSET__BZpoipsQ__"